import { RADIUS } from "@/styles";
import { Center, chakra } from "@chakra-ui/react";
import { useSelectedPersonValue } from "@shared/client";
import { motion } from "framer-motion";
import { useEffect, useState } from "react";
import { type BookCardProps } from "./bookCard.type";
import { ChoiceRoom, PersonCount, RoomInfo, Thumbnail } from "./components";
import { useRoomSelection } from "./hooks";

export const BookCard = ({ dayNight, currentRoom }: BookCardProps) => {
    const [isChoiceRoom, setIsChoiceRoom] = useState(false);
    const selectedPersonValue = useSelectedPersonValue();

    const { imgUrl, amountOfImgs, roomIdx, roomDetailInfo, price, addFee, addPerson, ...rest } = currentRoom;
    const { isAvailableBook, isPaidSite, isPriceOff } = rest;
    const { name, personOfCapacity, structure } = roomDetailInfo;

    const [newOnPrice, setNewOnPrice] = useState(price.normal);
    const [newOffPrice, setNewOffPrice] = useState(price.discount);
    const { handleRoomSelection } = useRoomSelection();
    const discountRate = Math.round(100 - (newOffPrice / newOnPrice) * 100);

    useEffect(() => {
        const params = {
            roomIdx: currentRoom.roomIdx,
            isSelected: isChoiceRoom,
            newOffPrice,
            person: { ...selectedPersonValue },
        };

        handleRoomSelection(params);
    }, [isChoiceRoom, newOffPrice]);

    return (
        <MotionWrapper
            initial={{ scaleX: 0 }}
            whileInView={{ scaleX: 1 }}
            viewport={{ once: true }}
            display="flex"
            alignItems="center"
            justifyContent="center"
            willChange="auto !important"
            w="100%"
            boxSizing="border-box"
            flexDir="column"
            rowGap="32px"
            border="none"
            sx={{ ...RADIUS(4) }}
        >
            <Center w="100%" flexDir="column" rowGap="32px">
                <Center
                    w="100%"
                    columnGap="24px"
                    justifyContent="flex-start"
                    alignItems="flex-start"
                    rowGap="24px"
                    flexDir="column"
                >
                    <Thumbnail
                        amountOfImgs={amountOfImgs}
                        imgUrl={imgUrl}
                        isAvailableBook={isAvailableBook}
                        roomIdx={roomIdx}
                        roomName={name}
                    />
                    <RoomInfo
                        isPriceOff={isPriceOff}
                        name={name}
                        discountRate={discountRate}
                        personOfCapacity={personOfCapacity}
                        structure={structure}
                    />
                </Center>
                {!isPaidSite && (
                    <Center w="100%">
                        <PersonCount
                            addFee={addFee}
                            addPerson={addPerson}
                            isChoiceRoom={isChoiceRoom}
                            personOfCapacity={personOfCapacity}
                            setNewOnPrice={setNewOnPrice}
                            setNewOffPrice={setNewOffPrice}
                            initialOnPrice={price.normal}
                            initialOffPrice={price.discount}
                            isAvailableBook={isAvailableBook}
                        />
                    </Center>
                )}
            </Center>
            <ChoiceRoom
                dayNight={dayNight}
                isAvailableBook={isAvailableBook}
                isChoiceRoom={isChoiceRoom}
                setIsChoiceRoom={setIsChoiceRoom}
                newOnPrice={newOnPrice}
                newOffPrice={newOffPrice}
                setNewOffPrice={setNewOffPrice}
                setNewOnPrice={setNewOnPrice}
                price={price}
            />
        </MotionWrapper>
    );
};

const MotionWrapper = chakra(motion.div);
